import React, { useState } from 'react';
import './Contact.css';

const API_ROOT = process.env.REACT_APP_API_URL || (window.location.port === '3000'
  ? '/api'
  : `${process.env.PUBLIC_URL || ''}/api`);

const Contact = () => {
  const [form, setForm] = useState({ name: '', facility: '', email: '', phone: '', type: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [serverMessage, setServerMessage] = useState('');

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrors(prev => ({ ...prev, [e.target.name]: '' }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setErrors({});
    setServerMessage('');

    const endpoint = `${API_ROOT}/quote`;

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const result = await response.json();

      if (!response.ok) {
        if (result.errors) {
          setErrors(result.errors);
        } else {
          setServerMessage(result.message || 'Unable to submit request.');
        }
        return;
      }

      setSubmitted(true);
      setForm({ name: '', facility: '', email: '', phone: '', type: '', message: '' });
    } catch (error) {
      setServerMessage('Network error. Please try again.');
    }
  };

  return (
    <section className="section contact-section" id="contact">
      <div className="container">
        <div className="contact-layout">
          <div className="contact-left">
            <div className="section-tag">📞 Contact Us</div>
            <h2 className="section-title">Start Your <span className="gradient-text">Supply Partnership</span></h2>
            <p className="section-sub">Ready to supply your facility with premium, compliant linens? Our procurement team will respond within 24 hours with a custom quote.</p>

            <div className="contact-info">
              {[
                { icon: '📧', label: 'Email', value: 'procurement@novacarelinens.com' },
                { icon: '📞', label: 'Phone', value: '1-800-NCL-LINEN' },
                { icon: '📍', label: 'Headquarters', value: 'Regional Distribution Centers — USA' },
                { icon: '🕒', label: 'Response Time', value: 'Within 24 Business Hours' },
              ].map((info, i) => (
                <div className="contact-info-item" key={i}>
                  <div className="contact-info-icon">{info.icon}</div>
                  <div>
                    <div className="contact-info-label">{info.label}</div>
                    <div className="contact-info-value">{info.value}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="contact-features">
              {['No minimum order for first trial', 'Free compliance documentation kit', 'Dedicated account manager assigned', 'Net-30 terms for qualified facilities'].map((f, i) => (
                <div className="contact-feature-item" key={i}>
                  <span className="cf-check">✓</span>
                  <span>{f}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="contact-right">
            {submitted ? (
              <div className="success-msg">
                <div className="success-icon">✅</div>
                <h3>Request Received!</h3>
                <p>Our procurement team will reach out within 24 business hours with a custom quote for your facility.</p>
                <button className="btn-primary" onClick={() => setSubmitted(false)}>Submit Another Request</button>
              </div>
            ) : (
              <form className="contact-form" onSubmit={handleSubmit}>
                <h3 className="form-title">Request a Custom Quote</h3>
                {serverMessage && <p className="form-server-message">{serverMessage}</p>}
                <div className="form-grid">
                  <div className="form-group">
                    <label>Your Name *</label>
                    <input name="name" required value={form.name} onChange={handleChange} placeholder="John Smith" />
                    {errors.name && <span className="field-error">{errors.name}</span>}
                  </div>
                  <div className="form-group">
                    <label>Facility Name *</label>
                    <input name="facility" required value={form.facility} onChange={handleChange} placeholder="General Hospital" />
                    {errors.facility && <span className="field-error">{errors.facility}</span>}
                  </div>
                  <div className="form-group">
                    <label>Email Address *</label>
                    <input name="email" type="email" required value={form.email} onChange={handleChange} placeholder="procurement@hospital.com" />
                    {errors.email && <span className="field-error">{errors.email}</span>}
                  </div>
                  <div className="form-group">
                    <label>Phone Number</label>
                    <input name="phone" value={form.phone} onChange={handleChange} placeholder="+1 (555) 000-0000" />
                    {errors.phone && <span className="field-error">{errors.phone}</span>}
                  </div>
                </div>
                <div className="form-group full">
                  <label>Facility Type *</label>
                  <select name="type" required value={form.type} onChange={handleChange}>
                    <option value="">Select your facility type...</option>
                    <option>Hospital / Health System</option>
                    <option>Long-Term Care / Nursing Home</option>
                    <option>Outpatient / Diagnostic Clinic</option>
                    <option>Surgical / OR Center</option>
                    <option>Rehabilitation Center</option>
                    <option>Other Healthcare Facility</option>
                  </select>
                  {errors.type && <span className="field-error">{errors.type}</span>}
                </div>
                <div className="form-group full">
                  <label>What products do you need? *</label>
                  <textarea name="message" required value={form.message} onChange={handleChange} rows={4} placeholder="e.g. 500 bed sheets (twin), 200 bath towels, 100 patient gowns monthly..." />
                  {errors.message && <span className="field-error">{errors.message}</span>}
                </div>
                {serverMessage && <p className="form-server-message">{serverMessage}</p>}
                <button type="submit" className="btn-primary form-submit">Submit Quote Request →</button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
